import { useTranslation } from "react-i18next";
import ContactCard from "./ContactCard";
import "../styles/ContactPageComponent.css";

export default function ContactPageComponent() {
  const { t } = useTranslation();
  const contactData = [
    {
      id: "secretariat",
      title: t("contact_secretariat"),
      value: "ASR CertPers",
    },
    {
      id: "phone",
      title: t("contact_phone"),
      value: "+40 770 532 157",
      href: "tel:+40770532157",
    },
    {
      id: "email",
      title: t("contact_email"),
      value: "office@asrcertpers.ro",
      href: "mailto:office@asrcertpers.ro",
    },
  ];

  return (
    <div className="contact-page">
      <h1 className="contact-page-title">{t("contacts_tab")}</h1>
      <div className="contact-page-cards">
        {contactData.map((contact) => (
          <ContactCard key={contact.id} {...contact} />
        ))}
      </div>
    </div>
  );
}
